import http from "@/common/http-common";
import store from "@/store";

class EnergyUseCatService {
  async loadAll() {
    return http().get("/api/v1/energy_use_cats.json").then(function(resp) {
      console.log("Inside EnergyUseCatService.loadAll, resp.data ==> ", resp.data);
      store.commit("updateEnergyUseCats", resp.data);
    })

  }
}

export default new EnergyUseCatService();